<template>
  <header id="main-header" class="main-header fixed-top" :class="headerBackground ? 'colorbackgroundOn' : 'colorbackgroundOff'">
    <nav
      class="
        main-nav
        container-xxl
        navbar navbar-expand-md navbar-light
        flex-nowrap
      "
      :class="[{mobileActive: navbarMobileVisible}]"
    >
      <button
        class="
          hamburger hamburger--slider
          navbar-toggle
          d-lg-none d-xm-block
        "
        type="button"
        :class="{ 'is-active': navbarMobileVisible }"
        @click="toggleMenu"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>

      <router-link to="/" class="navbar-brand ">
        <img
          src="@/assets/images/logo-rendimento.png"
          :alt="'Logotipo ' + $store.state.websiteName"
          :title="$store.state.websiteName"
        />
      </router-link>

      <ul class="navbar-nav align-items-center justify-content-end flex-grow-1">
        <div class="d-flex">
          <li class="nav-item d-none d-lg-flex">
            <router-link to="/#junte-se-a-nos-no-rendimento" class="nav-link">Quem somos </router-link>
          </li>

          <li class="nav-item d-none d-lg-flex">
            <router-link to="/vagas" class="nav-link">Oportunidades</router-link>
          </li>

          <li class="nav-item d-none d-lg-flex">
            <router-link to="/estagio" class="nav-link">Programa de estágio</router-link>
          </li>

          <li class="nav-item d-none d-lg-flex">
            <router-link to="/#beneficios" class="nav-link">Benefícios</router-link>
          </li>

          <li class="nav-item d-none d-lg-flex">
            <router-link to="/faq" class="nav-link">FAQ</router-link>
          </li>

        </div>

        <li
          class="nav-item d-none d-lg-flex"
          v-if="!this.$store.state.user.isAuth"
        >
          <button
            type="button"
            class="btn-cv "
            @click="sendToLogin()"
          >
          Cadastre seu Currículo
          </button>
        </li>

        <li
          class="nav-item ml-3 d-none d-lg-flex"
          @click="toggleMenu"
          v-if="this.$store.state.user.isAuth"
        >
          <b-dropdown
            variant="color-transparent"
            :text="firstName && 'Olá<br>, ' + firstName"
            class="nav-link"
            no-caret
            right
          >
            <template slot="button-content">
              <div class="d-flex align-items-center">
                <img
                  :src="avatar || require('@/assets/images/thumb_false.jpg')"
                  class="avatar-button rounded-circle border border-white"
                  style="width: 40px; height: 40px; object-fit: cover"
                />
                <div class="text-left ml-3 button-avatar-text" style="line-height: 1">
                  Olá,
                  <div class="d-flex">{{ firstName }}!</div>
                </div>
              </div>
            </template>

            <b-dropdown-item to="/meu-perfil">
              <PersonalDataIcon class="align-middle mr-3" /> Meu Perfil
            </b-dropdown-item>

            <b-dropdown-item @click="changeModal('change-password')">
              <pencil-icon class="align-middle mr-3" />Alterar Senha
            </b-dropdown-item>

            <b-dropdown-divider></b-dropdown-divider>

            <b-dropdown-item to="/meu-perfil#box-subscription">
              <file-check-outline-icon class="align-middle mr-3" />Candidaturas
            </b-dropdown-item>

            <b-dropdown-item @click="signOut">Sair</b-dropdown-item>
          </b-dropdown>
        </li>
      </ul>

      <ul class="navbar-nav navbar-mobile d-flex d-lg-none">
        <span class="navbar-mobile-bg" @click="toggleMenu"></span>

        <li class="nav-item">
          <router-link
            to="/#junte-se-a-nos-no-rendimento"
            class="nav-link"
            @click.native="navbarMobileVisible = false"
            >Quem somos</router-link
          >
        </li>

        <li class="nav-item">
          <router-link
            to="/vagas"
            class="nav-link"
            @click.native="navbarMobileVisible = false"
            >Oportunidades</router-link
          >
        </li>

        <li class="nav-item">
          <router-link
            to="/estagio"
            class="nav-link"
            @click.native="navbarMobileVisible = false"
            >Programa de estágio</router-link
          >
        </li>

        <li class="nav-item">
          <router-link
            to="/#beneficios"
            class="nav-link"
            @click.native="navbarMobileVisible = false"
            >Benefícios</router-link
          >
        </li>

        <li class="nav-item">
          <router-link
            to="/faq"
            class="nav-link"
            @click.native="navbarMobileVisible = false"
            >FAQ</router-link
          >
        </li>

        <li class="nav-item" v-if="this.$store.state.user.isAuth">
          <router-link
            to=""
            @click.native="
              navbarMobileVisible = false;
              changeModal('change-password');
            "
            class="nav-link"
            >Alterar Senha</router-link
          >
        </li>

        <li
          class="nav-item"
          v-if="
            !this.$store.state.user.isAuth || !this.$store.state.user.follower
          "
        >
          <div
            class="btn-cv"
            @click.native="navbarMobileVisible = false"
            @click="sendToLogin()"
          >
            Faça seu login
          </div>
        </li>

        <li class="nav-item" v-if="this.$store.state.user.isAuth">
          <a href="#" class="nav-link" @click="signOut"
            >Sair</a
          >
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import "@/components/icons/search";
import "@/components/icons/linkedin";
import "@/components/icons/facebook";
import PersonalDataIcon from "@/components/mlIcons/PersonalData";
import PencilIcon from "vue-material-design-icons/Pencil.vue";
import FileCheckOutlineIcon from "@/components/mlIcons/FileCheckOutline";

export default {
  name: "mainHeader",

  components: {
    PersonalDataIcon,
    PencilIcon,
    FileCheckOutlineIcon,
  },

  data() {
    return {
      headerBackground: false,
      scrolled: false,
      isTop: false,
      navbarMobileVisible: false,
    };
  },

  computed: {
    firstName() {
      if(this.$store.state.user){
        const profile = this.$store.state.user.profile;
        const socialName = profile.socialName;
        const name = profile.name.split(' ')[0];
        if(socialName){
          return socialName;
        } else if(window.signUp){
          return null
        } else if(name){
          return name;
        }
      }

      return null;
    },

    avatar() {
      return this.$store.state.user.profile.avatar;
    },
  },

  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },

  watch: {
    $route(to, from) {
      this.handleScroll();
    },
  },

  methods: {
    sendToLogin() {
      this.$store.commit("user/SET_NEXT_ROUTE", { path: "/vagas" });
      this.$store.commit("DEVISE_FORM", "login");
    },

    handleScroll (event) {
      let scrolledAfter = 150;
        let scrollY = window.scrollY || window.pageYOffset;
        if( scrollY > scrolledAfter || this.$route.name == 'ficha'){
          this.headerBackground = true;
        }else{
          this.headerBackground = false;
        }
      },

    signOut() {
      this.$store.dispatch("user/signOut");
      if (this.$route.meta.requiresAuth) this.$router.push("/");
    },

    toggleMenu() {
      this.navbarMobileVisible = !this.navbarMobileVisible;
    },

    changeModal(target) {
      this.$store.commit("DEVISE_FORM", target);
    },
  },
};
</script>

<style lang="scss" scoped>

.colorbackgroundOn{
  background-color: #fff;
}

.colorbackgroundOff{
  background-color: transparent !important;
  .nav-link{
    color: #fff !important;
  }
  .button-avatar-text {
    color: #fff;
  }
}
.btn-cv {
  border: 2px solid #00CFD9;
  background: transparent;
  color: #00CFD9;
  font-size: 14px;
  font-weight: bold;
  padding: 7px 29px;
  display: inline-block;
  border-radius: 16px;
  margin-left: 23px;

  &:hover{
      color: #0A1D6F !important;
      background: #00CFD9;
    }
}

.dropdown-item {
  padding: 8px 20px;

  &:not(:last-child) {
    font-weight: 500;
    color: theme-color("color-6");
  }

  .material-design-icon {
    font-size: 1.3rem;
  }

  &.active,
  &:active,
  &:hover,
  &:focus {
    background: white;
  }
}

.main-header {
  padding: 10px 50px;
  background: white;
  @media screen and (max-width: 1100px) {
    padding: 10px 15px;
  }
  &.secondaryBackground {
    background-image: linear-gradient(
      theme-color("header-primary-background") 100%,
      transparent
    );
  }


  .navbar-brand {
    margin: 0;
    padding: 0;

    @include media-breakpoint-down(md) {
      margin-left: 15px;
    }

    img {
      max-height: 28px;
    }
  }

  .main-nav {
    transition: padding 0.2s ease-in-out;

    &.mobileActive {
      .navbar-mobile {
        transform: translateX(0vw);

        .navbar-mobile-bg {
          opacity: 1;
          visibility: visible;
        }
      }
    }

    .navbar-nav > div {
      display: flex;
      justify-content: space-between;
      flex-grow: 0.7;

      .nav-link{
        font-size: 16px;
        color: #000;
      }
    }

    @include media-breakpoint-down(lg) {
      &.container {
        .navbar-nav {
          align-items: center;
          text-align: center;
        }
      }
    }

  }

  .navbar-mobile {
    .navbar-mobile-bg {
      display: none;
    }

    @include media-breakpoint-down(md) {
      width: 290px;
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      background: #fff;
      z-index: 10;
      transform: translateX(-100vw);
      transition: transform 0.3s ease-in-out;
      flex-direction: column !important;

      .nav-item {
        width: 100%;

        &.active {
          .nav-link {
            background-color: theme-color("color-1") !important;
            border-bottom: none !important;
          }
        }

        .nav-link {
          color: $body-color !important;
          padding: 1rem !important;
          text-transform: capitalize !important;
          text-align: left;
          &:hover {
            background-color: theme-color("color-1") !important;
          }
        }
      }

      .navbar-mobile-bg {
        display: block;
        width: 200vw;
        height: 100%;
        position: fixed;
        left: 290px;
        right: 0;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease-in-out 0.1s, visibility 0.01s linear;
      }
    }
  }
}
</style>